module.exports = __webpack_public_path__ + "static/media/1whitepine.b0fd397a.jpg";